/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnintegratedFieldsSchemaEntry } from './UnintegratedFieldsSchemaEntry';
import {
    UnintegratedFieldsSchemaEntryFromJSON,
    UnintegratedFieldsSchemaEntryFromJSONTyped,
    UnintegratedFieldsSchemaEntryToJSON,
    UnintegratedFieldsSchemaEntryToJSONTyped,
} from './UnintegratedFieldsSchemaEntry';
import type { CardSchemesConfiguration } from './CardSchemesConfiguration';
import {
    CardSchemesConfigurationFromJSON,
    CardSchemesConfigurationFromJSONTyped,
    CardSchemesConfigurationToJSON,
    CardSchemesConfigurationToJSONTyped,
} from './CardSchemesConfiguration';

/**
 * 
 * @export
 * @interface PaymentMethodOverridableConfiguration
 */
export interface PaymentMethodOverridableConfiguration {
    /**
     * 
     * @type {CardSchemesConfiguration}
     * @memberof PaymentMethodOverridableConfiguration
     */
    cardSchemesConfiguration?: CardSchemesConfiguration | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodOverridableConfiguration
     */
    paymentMethodDisplayLabel?: string | null;
    /**
     * 
     * @type {Array<UnintegratedFieldsSchemaEntry>}
     * @memberof PaymentMethodOverridableConfiguration
     */
    unintegratedFieldsSchema?: Array<UnintegratedFieldsSchemaEntry> | null;
}

/**
 * Check if a given object implements the PaymentMethodOverridableConfiguration interface.
 */
export function instanceOfPaymentMethodOverridableConfiguration(value: object): value is PaymentMethodOverridableConfiguration {
    return true;
}

export function PaymentMethodOverridableConfigurationFromJSON(json: any): PaymentMethodOverridableConfiguration {
    return PaymentMethodOverridableConfigurationFromJSONTyped(json, false);
}

export function PaymentMethodOverridableConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodOverridableConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'cardSchemesConfiguration': json['cardSchemesConfiguration'] === undefined ? undefined : json['cardSchemesConfiguration'] === null ? null : CardSchemesConfigurationFromJSON(json['cardSchemesConfiguration']),
        'paymentMethodDisplayLabel': json['paymentMethodDisplayLabel'] === undefined ? undefined : json['paymentMethodDisplayLabel'] === null ? null : json['paymentMethodDisplayLabel'],
        'unintegratedFieldsSchema': json['unintegratedFieldsSchema'] === undefined ? undefined : json['unintegratedFieldsSchema'] === null ? null : ((json['unintegratedFieldsSchema'] as Array<any>).map(UnintegratedFieldsSchemaEntryFromJSON)),
    };
}

export function PaymentMethodOverridableConfigurationToJSON(json: any): PaymentMethodOverridableConfiguration {
    return PaymentMethodOverridableConfigurationToJSONTyped(json, false);
}

export function PaymentMethodOverridableConfigurationToJSONTyped(value?: PaymentMethodOverridableConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cardSchemesConfiguration': CardSchemesConfigurationToJSON(value['cardSchemesConfiguration']),
        'paymentMethodDisplayLabel': value['paymentMethodDisplayLabel'],
        'unintegratedFieldsSchema': value['unintegratedFieldsSchema'] == null ? undefined : ((value['unintegratedFieldsSchema'] as Array<any>).map(UnintegratedFieldsSchemaEntryToJSON)),
    };
}

